export type RootPathParams = {
  expenseClaimRequestId?: string;
};

export const root = '/expense-claims/requests';
export const rootPath = `${root}/:expenseClaimRequestId?`;
export const requestExpenseClaimPath = `${root}/new`;
export const getExpenseClaimRequestPath = (expenseClaimRequestId: string) =>
  `${root}/${expenseClaimRequestId}`;
